import { Formats, RichTranslationValues, useTranslations } from "next-intl"

export type TranslateProps = {
  i18nKey: string
  values?: RichTranslationValues | undefined
  formats?: Partial<Formats> | undefined
}

export function Translate({ i18nKey, values, formats }: TranslateProps) {
  const t = useTranslations()

  return t.rich(
    i18nKey,
    {
      h5: (chunks) => (
        <h5 className="font-secondary text-title-s font-bold">{chunks}</h5>
      ),
      p: (chunks) => <p className="text-paragraph-m">{chunks}</p>,
      strong: (chunks) => <strong>{chunks}</strong>,
      u: (chunks) => <u>{chunks}</u>,
      br: () => <br />,
      b: (chunks) => <b>{chunks}</b>,
      ...values,
    },
    formats,
  )
}
